// Lightweight client-side analytics tracker.
// Fires one event per page-load to POST /api/analytics/track.
// Session id is persisted in sessionStorage (cleared on tab close).

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "winfield_session";

const getSessionId = () => {
  if (typeof window === "undefined") return "ssr";
  let sid = window.sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    window.sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

export const trackPageview = (extra = {}) => {
  if (typeof window === "undefined" || !API_BASE) return;
  const body = {
    session_id: getSessionId(),
    path: window.location.pathname + window.location.search,
    referrer: document.referrer || null,
    language:
      window.localStorage.getItem("winfield_lang") ||
      (navigator.language || "en").slice(0, 2),
    screen: `${window.innerWidth}x${window.innerHeight}`,
    user_agent: navigator.userAgent,
    ...extra,
  };
  // Fire-and-forget; never block UI on analytics failure.
  fetch(`${API_BASE}/api/analytics/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
};
